<template>
  <div>
    <div>
      <SPreloader />
      <SSubHeader :pageName="'Groups'" :backButton="true" />
      <div class="header-spacer"></div>
      <div class="container">
        <div class="row">
          <!-- Main Content -->
          <div class="col col-12">
            <SButtonMaterial
              class="create-group-btn"
              buttonType="button"
              color="primary"
              textColor="white"
              materialClass="dense"
              text="create group"
              iconLeftText="groups"
              iconColor="white"
              @button="openNewGroupModal"
            />
          </div>
          <main
            class="col col-xl-9 order-xl-1 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12" id="gfilter"
          >
            <SSelectMaterial
              class="filter"
              :options="options"
              multiple="false"
              :choice="choice"
              v-model="choice.options"
              label="Sort by"
              :selectedFilters="selectedFilters"
              ref="sfilter"
              @md-selected="$emit('button', choice)"
            ></SSelectMaterial>
            <div id="newsfeed-items-grid" class="groups-box-outer">
              <div
                v-for="group in groupsWithModeratedIds"
                :key="group.id"
                class="groups-box-inner"
              >
                <CardGroup :group="group" v-if="!group.ads" />
              </div>
            </div>
          </main>

          <aside
            class="col col-xl-3 order-xl-2 col-lg-12 order-lg-2 col-md-12 col-sm-12 col-12"
          >
            <SNewGroupWidget class="wide-screen" />
            <GroupsYouMayLike :groups="groupsYouMayLIke" />
          </aside>
        </div>
      </div>
    </div>
    <Footer />
    <Modal
      buttonName="GOT IT"
      id="welcome-membership"
      imgHeaderPath="/img/group-modal-header.svg"
      title="Membership"
      @button="closeModal()"
      @close="closeModal()"
      ref="welcomeMembership"
      data-cy="groupsModal"
      :materialButton="true"
    >
      <h5 class="welcome-title">Community spot ahead!</h5>
      <p class="welcome-content">You are a member of all these groups.</p>
      <DontShowAgainModal class="dont-show-check" @option="saveOption" />
    </Modal>

    <a class="back-to-top arrow-top" href="#" v-if="pageBottom">
      <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SNewGroupWidget from "@/components/atoms/SNewGroupWidget";
import GroupsYouMayLike from "@/components/molecules/GroupsYouMayLike";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import CardGroup from "@/components/atoms/CardGroup";
import SPreloader from "@/components/organisms/SPreloader.vue";
import Modal from "@/components/atoms/Modal.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import DontShowAgainModal from "@/material-components/atoms/DontShowAgainModal";
import modalType from "@/enum/modal-type";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SSelectMaterial from "@/material-components/molecules/SSelectMaterial.vue";
import Footer from "@/templates/Footer";

export default {
  name: "MyGroupsPage",
  mixins: [GroupHelperVue, UserHelperVue],
  components: {
    SNewGroupWidget,
    GroupsYouMayLike,
    CardGroup,
    SPreloader,
    Modal,
    DontShowAgainModal,
    SSubHeader,
    SSelectMaterial,
    SButtonMaterial,
    Footer,
  },
  data() {
    return {
      dontShowModalAgain: false,
      options: [
        { label: "New to old", value: 1, dataCy: "giveFilter" },
        { label: "Old to new", value: 2, dataCy: "receiveFilter" },
        { label: "A-Z", value: 3, dataCy: "receiveFilter" },
        { label: "Z-A", value: 4, dataCy: "receiveFilter" },
      ],
      choice: {
        options: [],
      },
    };
  },
  computed: {
    groupsWithModeratedIds() {
      let result = [];
      this.myModeratedGroups.forEach((item) => {
        result.push(item.groupId);
      });
      let myGroups = this.myGroups.map((element) => {
        if (result.includes(element.groupId)) {
          return {
            ...element,
            myModeratedGroup: true,
          };
        } else {
          return {
            ...element,
          };
        }
      });
      myGroups = myGroups.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      return myGroups;
    },
    selectedFilters() {
      let filters = [];
      this.options.forEach((filter) => {
        if (this.choice.options.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      return filters;
    },
  },
  methods: {
    ...mapActions(["setNewGroupPrivacy"]),
    openNewGroupModal() {
      this.setNewGroupPrivacy(1);
      $("#create-group").modal("show");
    },
    async closeModal() {
      if (this.dontShowModalAgain === true) {
        await this.saveOptionDontShowAgain();
      }
      this.$refs.welcomeMembership.closeModal();
    },
    makeSearch(value) {
      this.filter = value;
    },
    clearFilter() {
      this.choice = {
        options: [],
      };
    },
    removeFilter(removed) {
      if (this.options.includes(removed)) {
        this.choice.options = this.choice.options.filter((filter) => {
          return filter !== removed.value;
        });
      } 
    },
    saveOption(value) {
      this.dontShowModalAgain = value;
    },
    async saveOptionDontShowAgain() {
      if (this.dontShowModalAgain === true) {
        const userModal = {
          modal_Type: modalType.MEMBERSHIP_PAGE,
          user_Id: this.loggedUser.id,
        };
        await this.saveDontShowAgain(userModal);
      }
    },
    async getDontShowOption() {
      const userModal = {
        modalType: modalType.MEMBERSHIP_PAGE,
        userId: this.loggedUser.id,
      };
      let response = await this.getDontShowModal(userModal);
      this.dontShowModalAgain = response.dontShowModal;
    },
    async showModal() {
      await this.getDontShowOption();
      if (this.dontShowModalAgain === false) {
        $("#welcome-membership").modal("show");
      }
    },
  },
  created() {
    this.getMyGroups();
    this.fetchMyModeratedGroups();
    this.fetchGroupsYouMayLike();
  },
  mounted() {
    setTimeout(() => {
      this.showModal();
    }, 1001);
  },
};
</script>
<style lang="scss" scoped>
.welcome-title {
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  align-items: center;
  text-align: center;
  letter-spacing: 1.25px;
  padding-top: 2rem;
  padding-bottom: 2rem;
  color: $primary;
  opacity: 0.8;
}
.welcome-content {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  align-items: center;
  text-align: center;
  letter-spacing: 1.25px;
  color: $black;
  mix-blend-mode: normal;
  opacity: 0.7;
}
.dont-show-check {
  padding-bottom: 0.5rem;
}
.groups-box-outer {
  background-color: $white;
  margin-right: 2rem;
  margin-bottom: 3rem;
  padding: 3rem 3rem 1rem 3rem;
  border-radius: 4px;
}
.create-group-btn {
  display: none;
}
.groups-box-inner {
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.25));
  margin-bottom: 48px;
}
@media screen and (max-width: 600px) {
  .groups-box-outer {
    margin-right: unset;
    padding: 1rem;
  }
}
@media screen and (max-width: 1198px) {
  .container {
    padding-top: 1rem;
  }
  .wide-screen {
    display: none;
  }
  .groups-box-outer {
    margin-right: unset;
  }
  .create-group-btn {
    display: flex;
    margin: auto;
    height: 40px;
    font-size: 14px;
  }
}
@media screen and (max-width: 1014px) {
  .container {
    padding-top: 3rem;
  }
}
.filter {
  width: 130px;
}

</style>

<style lang="scss">
.text-dont-show {
  color: $black;
  opacity: 0.7;
}
#welcome-membership .create-friend-group .modal-header-img {
  transform: translatex(0px) translatey(0px);
}
#welcome-membership {
  transform: translatex(0px) translatey(0px);
}
#gfilter .md-menu.md-select {
  height: 50px;
}
#gfilter label {
  top: 17px;
  left: 10px;
}
#gfilter .material-select .md-menu input {
  font-size: 19px !important;
}
.material-select {
  margin: 0 0 10px 0 !important;
}
#gfilter .md-field.md-focused label, .md-field.md-has-value label {
  top: 0px !important;
}
</style>
